module.exports = __webpack_public_path__ + "img/join-background-1.ac834d80.png";